<template>
  <div>
    <div class="actions row col-lg-12 mb-5 p-0 m-0">
      <div class="actions-left col-lg-6 row p-0 m-0">
       <span class="col-lg-6 m-0 p-0 text-left"> 
         <button v-bind:class="{'font-weight-bold': status == 'active'}" class="status-button" @click="status = 'active'">Ativos</button> ({{activePlaces}}) | <button v-bind:class="{'font-weight-bold': status == 'archived'}" class="status-button" href="#" @click="status = 'archived'">Arquivados</button> ({{archivedPlaces}})
       </span>
      </div>
      <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0">
        <button type="button" class="btn btn-primary" @click="addInfo">Adicionar Novo</button>
      </div>
    </div>
    <SearchBar @search-clicked="searchClicked"></SearchBar>

    <CTableWrapper ref="table" hover striped :caption="caption" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :loading="loading" :sorter="{external: true}" :defaultSorterValue="sorterValue" @sorter-value-changed="sorterValueChanged">    
    </CTableWrapper>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from '../controls/PaginatedTable.vue'
import SearchBar from '../controls/SearchBar.vue'
import router from '@/router';
import InputGetPlaces from "@/classes/InputGetPlaces";
import InputUpdateStatus from "@/classes/InputUpdateStatus";

const ARCHIVED_STATUS = 0;
const ACTIVE_STATUS = 1;

export default {
  components: { CTableWrapper, SearchBar },
  data () {
    return {
      searchText: '',
      caption: 'Locais',
      itemsPerPage: 10,
      currentPageAux: 0,
      fields: [
        { key: 'name', label: 'Nome', _classes: 'font-weight-bold', sorter: true },
        { key: 'lastRegister', label: 'Último Registo', sorter: false },
        { key: 'last90Days', label: 'Últimos 90 dias', sorter: false }
      ],
      actions: [
        { key: 'view', label: 'Ver' },
        { key: 'archive', label: 'Arquivar' }
      ],
      sorterValue: { column: 'name', asc: true },
      status: 'active',
      loading: false
    }
  },
  computed: {
    ...mapState('places', ['listOutput']),
    ...mapState('places', ['updateStatusPlace']),
    places: function() {
      return this.listOutput && this.listOutput.obj ? this.listOutput.obj : null;
    },
    items: function()
    {
      return this.places ? this.places.places : [];
    },
    pages: function()
    {
      return this.places ? this.places.pagesNumber : 1;
    },
    activePlaces: function()
    {
      return this.places ? this.places.active : 0;
    },
    archivedPlaces: function()
    {
      return this.places ? this.places.archived : 0;
    }
  },
  mounted: function()
  {
    this.updateItemsRequested(1, this.itemsPerPage);
  },
  methods: {
    ...mapActions('places', ['getList']),
    ...mapActions('places', ['updateStatus']),
    rowClicked (item, index) {
      this.$router.push({name: "EditPlaces", params: { id: item.id } });
    },
    actionClicked(item, action){
      var inputUpdateStatus = new InputUpdateStatus(item.id);

      switch(action.key)
      {
        case 'view':
        {
          this.$router.push({name: "EditPlaces", params: { id: item.id } });
          break;
        }
        case 'archive':
        {
          if(confirm(`Tem a certeza que pretende arquivar o item: "${item.name}"?`)){
            inputUpdateStatus.status = ARCHIVED_STATUS;
          }
          break;
        }
        case 'activate':
        {
          if(confirm(`Tem a certeza que pretende activar o item: "${item.name}"?`)){
            inputUpdateStatus.status = ACTIVE_STATUS;
          }
          break;
        }
        default:
        {
          throw "The provided action is not supported!"; 
        }
      }

      if(inputUpdateStatus.status != undefined)
      {
        this.loading = true;
        this.updateStatus(inputUpdateStatus);
      }
    },
    updateItemsRequested(currentPage, itemsPerPage)
    {
      this.loading = true;
      this.itemsPerPage = itemsPerPage;
      this.currentPageAux = currentPage;


      var statusIndex = this.status == 'active' ? ACTIVE_STATUS : ARCHIVED_STATUS;

      var input = new InputGetPlaces(currentPage, itemsPerPage, this.searchText, statusIndex, this.sorterValue.asc ? 0 : 1);

      this.getList(input); 
    },
    sorterValueChanged(value)
    {
      this.sorterValue = value;
    },  
    addInfo () 
    {
      router.push({ path: '/locais/adicionar' });
    },
    searchClicked(searchText)
    {
      this.searchText = searchText;
      this.$refs.table.reset();

      this.updateItemsRequested(1, this.itemsPerPage);
    }
  },
  watch: 
  { 
    sorterValue:
    {
      handler: function(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    status: function (val) {
      // Update actions
      switch(val) {
        case 'active':
        {
          this.actions = [
            { key: 'view', label: 'Ver' },
            { key: 'archive', label: 'Arquivar' }
          ];
          break;
        }
        case 'archived':
        {
          this.actions = [
            { key: 'view', label: 'Ver' },
            { key: 'activate', label: 'Ativar' }
          ];
          break;
        }
        default:
        {
          throw "The provided status is not supported!"; 
        }
      }

      // Update items
      this.updateItemsRequested(1, this.itemsPerPage);
    },
    listOutput:
    {
      handler: function(val)
      {
        this.loading = false;
      },
      deep: true // Watch for changes on the properties
    },
    updateStatusPlace: function(val)
    {
      if(val)
      {
        this.updateItemsRequested(this.currentPageAux, this.itemsPerPage);
      }
    }
  }
}
</script>

 
<style>
th
{
  border-top: none !important;
}

tr
{
  cursor: pointer;
}

.status-button
{
  border: none;
  padding: 0;
  text-decoration: underline;
  color: #321fdb;
}
</style> 